export default function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/order/none.js
// module id = 69
// module chunks = 0